export { default } from './InstallmentsAccordion'
